import { FeatureCollection, Geometry } from "geojson";
import { mapActive } from "../utils/map-utils";
import { CustomSource } from "../models/CustomSource";

const sourceName = CustomSource.CopyNodes;
const sourceConfig: mapboxgl.GeoJSONSourceSpecification = {
  type: "geojson",
  promoteId: "id",
  data: {
    type: "FeatureCollection",
    features: [],
  },
};

const lineStrokeLayerConfigTemplate: mapboxgl.LineLayerSpecification = {
  id: "",
  type: "line",
  source: "",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-color": ["get", "stroke"],
    "line-width": 10,
  },
  filter: ["==", "$type", "LineString"],
};

const strokeLayerName = `${sourceName}-stroke`;
const strokeLayerConfig: mapboxgl.LineLayerSpecification = {
  ...lineStrokeLayerConfigTemplate,
  source: sourceName,
  id: strokeLayerName,
};

const lineLayerName = `${sourceName}-line`;
const lineLayerConfig: mapboxgl.LineLayerSpecification = {
  id: lineLayerName,
  source: sourceName,
  type: "line",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-color": ["get", "line"],
    "line-width": 3,
  },
  filter: ["==", "$type", "LineString"],
};

const directionLayerName = `${sourceName}-direction`;
const directionLayerConfig: mapboxgl.SymbolLayerSpecification = {
  id: directionLayerName,
  source: sourceName,
  type: "symbol",
  layout: {
    "symbol-placement": "line",
    "symbol-spacing": 50,
    "icon-image": "chevron-icon",
    "icon-rotation-alignment": "map",
    "icon-size": 0.5,
  },
};

function config(map: mapboxgl.Map) {
  map.addSource(sourceName, sourceConfig);
  map.addLayer(strokeLayerConfig);
  map.addLayer(directionLayerConfig);
  map.addLayer(lineLayerConfig);
}

function resetConfig(map: mapboxgl.Map) {
  map.removeLayer(strokeLayerConfig.id);
  map.removeLayer(directionLayerConfig.id);
  map.removeLayer(lineLayerConfig.id);
  map.removeSource(sourceName);
}

function update(map: mapboxgl.Map, geoJson: FeatureCollection) {
  if (mapActive(map)) {
    const source = map.getSource(sourceName) as mapboxgl.GeoJSONSource;
    source.setData(geoJson);
  }
}

function extendBounds(
  bounds: mapboxgl.LngLatBounds,
  geoJson: FeatureCollection
) {
  geoJson.features.forEach((feature) => {
    const geometry = feature.geometry as Geometry;
    switch (geometry.type) {
      case "Point": {
        bounds.extend(geometry.coordinates as [number, number]);
        break;
      }
      case "LineString": {
        (geometry.coordinates as [number, number][]).forEach((coords) =>
          bounds.extend(coords)
        );
        break;
      }
      default:
        break;
    }
  });
}

export const copyNodesMapSource = {
  config,
  update,
  extendBounds,
  resetConfig,
};
